import DialogBaseTitle from './DialogBaseTitle';

export default DialogBaseTitle;
